import { Collaborateur } from "../types/models/collaborateur";
import { HttpClient } from "./http-client";

export class ClientService {
  private readonly http: HttpClient;

  constructor(apiUrl: string) {
    this.http = new HttpClient(apiUrl);
  }

  async getAllClients() {
    return this.http.get("/api/utilisateurs");
  }

  async createClient(client: any): Promise<void> {
    await this.http.post("/api/utilisateurs", client);
  }

  async deleteClient(clientId: number): Promise<void> {
    await this.http.delete(`/api/utilisateurs/${clientId}`);
  }

  // PUT /api/utilisateurs/{idUtilisateur} — identité d'un Utilisateur
  // (nom/prenom/telephone). C'est la route à utiliser pour que la personne
  // connectée mette à jour son propre profil, qu'elle soit ou non par
  // ailleurs Collaborateur d'une entreprise.
  async updateUtilisateur(
    idUtilisateur: number,
    data: { nom: string; prenom: string; telephone: string },
  ): Promise<void> {
    await this.http.put(`/api/utilisateurs/${idUtilisateur}`, data);
  }

  async getCollaborateurById(idCollaborateur: number): Promise<Collaborateur> {
    return this.http.get<Collaborateur>(
      `/api/collaborateurs/${idCollaborateur}`,
    );
  }

  async getAllCollaborateurs(): Promise<Collaborateur[]> {
    return this.http.get<Collaborateur[]>("/api/collaborateurs");
  }

  // Édition par le gestionnaire (ristourne, service minimal, statut pro).
  // PUT /api/collaborateurs/{idCollaborateur}/admin — n'accepte pas nom/
  // prenom/telephone/email, qui vivent désormais sur le Contact (voir
  // ContactService.updateContact).
  async updateCollaborateurAdmin(
    idCollaborateur: number,
    data: {
      idMinimalService: number | null;
      ristourne: number;
      isProfessionnel: boolean;
      customData?: Record<string, string>;
    },
  ): Promise<void> {
    await this.http.put(`/api/collaborateurs/${idCollaborateur}/admin`, data);
  }

  // Édition en libre-service par le collaborateur lui-même (champs custom
  // uniquement). PUT /api/collaborateurs/{idCollaborateur}.
  async updateCollaborateurCustomData(
    idCollaborateur: number,
    customData: Record<string, string>,
  ): Promise<void> {
    await this.http.put(`/api/collaborateurs/${idCollaborateur}`, {
      customData,
    });
  }
}
